var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLinkBrokenModern = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.333 7.667 2.828 9.172a2.828 2.828 0 0 0 0 4v0a2.829 2.829 0 0 0 4 0l1.505-1.505M11.667 8.333l1.505-1.505a2.829 2.829 0 0 0 0-4v0a2.829 2.829 0 0 0-4 0L7.667 4.333M2 6h1.333M6 3.333V2M4 4l-.943-.943M14 10h-1.333M10 12.667V14M12.39 12.39l.943.943"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLinkBrokenModern, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LinkBrokenModern.71a136f2.svg";
export { ForwardRef as ReactComponent };